import React from "react";
import Contact from "../Componant-contact/Contact";

export default function FR() {
  return (
    <>
      <h3 className="text-center">Hello This is a Medical Organization</h3>
      <Contact />
    </>
  );
}
